var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9847 4.33413C11.7826 4.33413 12.4293 3.68734 12.4293 2.88948C12.4293 2.09162 11.7826 1.44482 10.9847 1.44482C10.1868 1.44482 9.54004 2.09162 9.54004 2.88948C9.54004 3.68734 10.1868 4.33413 10.9847 4.33413Z",
    fill: "#249DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8785 2.31681C14.5183 2.31681 15.0369 1.79818 15.0369 1.15841C15.0369 0.518637 14.5183 0 13.8785 0C13.2387 0 12.7201 0.518637 12.7201 1.15841C12.7201 1.79818 13.2387 2.31681 13.8785 2.31681Z",
    fill: "#249DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7358 19.7331L12.7201 10.117V7.22768H14.4555V5.20605H4.62469V7.22768H6.36006V10.117L0.348864 19.7331C0.125233 20.1401 0 20.6097 0 21.1062C0 22.7029 1.29259 24 2.89378 24H16.1909C17.7876 24 19.0847 22.7074 19.0847 21.1062C19.0847 20.6097 18.9594 20.1401 18.7358 19.7331ZM4.95119 16.1863L8.38616 10.694V7.2232H10.6985V10.694L14.1335 16.1863H4.95119Z",
    fill: "#249DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.f9f9b9956a426a3ab0dc34bf305d509d.svg";
export { ForwardRef as ReactComponent };